import { FIRESTORE_COLLECTIONS } from "@core/constants/collections.constants";
import { BaseFirestoreRepository } from "core/base-firestore.repository";

import { Company } from "./company.model";

export default class CompanyRepository extends BaseFirestoreRepository<Company> {
  constructor() {
    super(FIRESTORE_COLLECTIONS.COMPANIES);
  }
}
